import type { IconType } from "@memorang/ui/src/types";

const rankStyles = [
	// Gold
	{
		podiumBg: "rgb(255, 224, 131)",
		textColor: "rgb(35, 27, 0)",
		height: 156,
		marginTop: 16,
		avatarSize: 56,
	},
	// Silver
	{
		podiumBg: "rgb(219, 228, 230)",
		height: 128,
		textColor: "rgb(47, 21, 0)",
		marginTop: 16,
		avatarSize: 48,
	},
	// Bronze
	{
		podiumBg: "rgb(255, 220, 195)",
		textColor: "rgb(47, 21, 0)",
		height: 112,
		marginTop: 16,
		avatarSize: 40,
	},
];

const isScreenshotMode = false;

export const isMocked = false;
export const testRedeemableProducts = [
	{
		id: "123",
		icon: "https://memorang-prod-icon.s3.amazonaws.com/icon/icon_bundle_45.png",
		title: "NCLEX-RN",
		description: "Study-Pack",
		codes: ["1234", "12345"],
		bundleType: "PRACTICE_TEST",
	},
];

export const blackListedStudypackIdsForWeb: number[] = [];
export const defaultMasteryLabels = {
	low: "Needs Work",
	medium: "Almost There",
	high: "Mastered",
	none: "Not Answered",
};

const skillIconMap: Record<string, IconType> = {
	Writing: "file-document-edit-outline",
	写作: "file-document-edit-outline",
	ライティング: "file-document-edit-outline",
	Listening: "ear-hearing",
	听力: "ear-hearing",
	リスニング: "ear-hearing",
	Speaking: "microphone-outline",
	口语: "microphone-outline",
	スピーキング: "microphone-outline",
	Reading: "book-open-page-variant-outline",
	阅读: "book-open-page-variant-outline",
	読解: "book-open-page-variant-outline",
	リーディング: "book-open-page-variant-outline",
	"Reading & Listening": "book-open-page-variant-outline",
	"Speaking & Writing": "microphone-outline",
};
export const getBrightcoveVideoUrl = (videoId: number) =>
	`https://players.brightcove.net/2324982687001/PYxPM5GJJ_default/index.html?videoId=${videoId}`;
export { rankStyles, isScreenshotMode, skillIconMap };
